import {useQuery} from '@apollo/client'

import {Divider, Paper, Typography} from '@material-ui/core'

import Skeleton from 'react-loading-skeleton'

import {
  INSTRUCTOR_CONTEXT,
  formatCompactNominal,
} from '../../../utils/contributor-helpers'

import {USER_ID} from '../../../utils/globals'
import {GET_CONTRIBUTOR_WISHLIST_STATS} from '../../../graphql/queries'

const aggregatesList = [
  {
    key: 'course_wishlists',
    label: 'Course',
  },
  {
    key: 'ebook_wishlists',
    label: 'E-Book',
  },
  {
    key: 'audiobook_wishlists',
    label: 'Audiobook',
  },
  {
    key: 'event_wishlists',
    label: 'Event',
  },
  {
    key: 'microlearning_wishlists',
    label: 'Microlearning',
  },
] as const

const ContributorWishlistAggregateCard = () => {
  const {data} = useQuery(GET_CONTRIBUTOR_WISHLIST_STATS, {
    fetchPolicy: 'cache-and-network',
    variables: {
      userId: USER_ID,
    },
    context: INSTRUCTOR_CONTEXT,
  })

  const totalItems = data
    ? data.course_wishlists.aggregate.count +
      data.ebook_wishlists.aggregate.count +
      data.audiobook_wishlists.aggregate.count +
      data.event_wishlists.aggregate.count +
      data.microlearning_wishlists.aggregate.count
    : 0

  return (
    <Paper>
      <Typography color="secondary" className="px-6 py-4 font-bold">
        Wishlisted
      </Typography>

      <Divider />

      <div className="p-6">
        <Typography
          title={`${totalItems} items wishlisted`}
          color="secondary"
          className="text-2xl font-bold"
        >
          {data ? formatCompactNominal(totalItems) : <Skeleton width={44} />}
        </Typography>
      </div>

      <div className="grid gap-2 p-6 pt-0">
        {aggregatesList.map((item) => (
          <div key={item.key} className="flex justify-between gap-2">
            <span>{item.label}</span>
            <Typography color="secondary" className="font-bold">
              {data ? (
                formatCompactNominal(data[item.key].aggregate.count)
              ) : (
                <Skeleton width={29} />
              )}
            </Typography>
          </div>
        ))}
      </div>
    </Paper>
  )
}

export default ContributorWishlistAggregateCard
